import CTA from 'components/CTA';
import Cards4IconBg from 'components/Cards4IconBg';
import CheckIconGrid from 'components/CheckIconGrid';
import FeatureBanner from 'components/FeatureBanner';
import HeadingAndDesc from 'components/HeadingAndDesc';
import IconContent from 'components/IconContent';
import Metadata from 'components/Metadata';
import Steps from 'components/Steps';
import ThreeCardsImage from 'components/ThreeCardsImage';
import TwoColList from 'components/TwoColList';
import PropTypes from 'prop-types';
import React from 'react';
import Example from './Example';
import Video from './Video';

const Website = ({ data }) => {
  const {
    websitePage: {
      title,
      meta: { description, breadcrumb },
      banner,
      featuresHeading,
      featuresList,
      threeCardsHeading,
      threeCardsList,
      twoColsHeading,
      twoCols,
      videoHeading,
      videoList,
      videolink,
      exampleHeading,
      exampleList,
      exampleTags,
      CTAText,
      cards4,
      footer
    }
  } = data;
  return (
    <>
      <Metadata title={title} description={description} />
      <FeatureBanner data={banner}  breadcrumb={breadcrumb} />
      <HeadingAndDesc data={{"heading": `${featuresHeading.heading}`, "desc": `${featuresHeading.desc}`}} />
      <IconContent data={featuresList} columnCount={4} smallIcon wrapper="L" />
      <HeadingAndDesc data={{"heading": `${threeCardsHeading.heading}`, "desc": `${threeCardsHeading.desc}`}} theme="Grey" />
      <ThreeCardsImage data={threeCardsList} padding="BottomL" theme="Grey" />
      <HeadingAndDesc data={{"heading": `${twoColsHeading.heading}`, "desc": `${twoColsHeading.desc}`}} theme="Blue" />
      <TwoColList data={twoCols} padding="BottomL" theme="Blue" />
      <HeadingAndDesc data={{"heading": `${videoHeading.heading}`, "desc": `${videoHeading.desc}`}} />
      <CheckIconGrid data={videoList} />
      <Video data={videolink} wrapper="M" padding="None" />
      <HeadingAndDesc data={{"heading": `${exampleHeading.heading}`, "desc": `${exampleHeading.desc}`}} theme="Dark" />
      <Example data={exampleList} tags={exampleTags} theme="Dark" />
      <CTA {...CTAText} />
      <Cards4IconBg data={cards4} />
      <Steps data={footer} theme="Grey" />
    </>
  );
}

Website.propTypes = {
  data: PropTypes.object,
}

export default Website;